import { Order } from '~/@types/table/order';
import { apiClient } from '~/api/client';
import axios from '~/utils/axios';

export type IndexParams = {
  nmls: string;
  does_tpo?: boolean;
  loan_purpose?: string[];
  loan_type?: string[];
  property_indicator_code?: string[];
  mortgage_document_type_code?: string[];
  land_use_code?: string[];
  real_estate_company?: string[];
  tpo_company_name?: string[];
  page: number;
  limit: number;
  sort_field?: string;
  order?: Order;
  period: Period;
};

export type ExportParams = Omit<IndexParams, 'page' | 'limit'>;

const buildFilters = (params: {
  loan_type?: string[];
  real_estate_company?: string[];
  property_indicator_code?: string[];
  mortgage_document_type_code?: string[];
  land_use_code?: string[];
  loan_purpose?: string[];
  tpo_company_name?: string[];
}) => {
  const loanTypeFilters = params.loan_type
    ?.map((loanType) => `&filter[loan_type][]=${loanType}`)
    .join('');

  const realEstateCompanyFilters = params.real_estate_company
    ?.map((realEstateCompany) => `&filter[real_estate_company][]=${realEstateCompany}`)
    .join('');

  const propertyIndicatorFilters = params.property_indicator_code
    ?.map((code) => `&filter[property_indicator_code][]=${code}`)
    .join('');

  const mortgageDocumentTypeFilters = params.mortgage_document_type_code
    ?.map((code) => `&filter[mortgage_document_type_code][]=${code}`)
    .join('');

  const landUseFilters = params.land_use_code
    ?.map((code) => `&filter[land_use_code][]=${code}`)
    .join('');

  const tpoCompanyNameFilters = params.tpo_company_name
    ?.map((companyName) => `&filter[tpo_company_name][]=${companyName}`)
    .join('');

  const loanPurposeFilters =
    params.loan_purpose?.map((loanPurpose) => `&filter[loan_purpose][]=${loanPurpose}`).join('') ||
    '';

  return `${loanTypeFilters}${propertyIndicatorFilters}${mortgageDocumentTypeFilters}${landUseFilters}${realEstateCompanyFilters}${tpoCompanyNameFilters}${loanPurposeFilters}`;
};

export const index = async (params: IndexParams) => {
  const filters = buildFilters(params);

  return apiClient.get(`/loan_transactions?${filters}`, {
    params: {
      'sort[field]': params.sort_field,
      'sort[order]': params.order,
      loan_officer_nmls: params.nmls,
      does_tpo: params.does_tpo,
      period: params.period,
      page: params.page,
      limit: params.limit,
    },
  });
};

export const exportTransactions = async (params: ExportParams) => {
  const filters = buildFilters(params);

  return axios.get(`/api/loan_transactions/export?${filters}`, {
    responseType: 'blob',
    params: {
      'sort[field]': params.sort_field,
      'sort[order]': params.order,
      loan_officer_nmls: params.nmls,
      does_tpo: params.does_tpo,
      period: params.period,
    },
  });
};
